import { useEffect, useState, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { useGlobalState } from '@ta-interaktiv/utils'

export const Title = ({
  id,
  text,
  sub,
  hideNumbers,
}: {
  id: string
  text: string
  sub: string
  hideNumbers?: boolean
}) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const themeContext = useContext(ThemeContext)
  const [elements, setElements] = useGlobalState<{[x:string]: HTMLDivElement}>('elements', {})

  useEffect(() => {
    if (container) {
      setElements({ ...elements, [id]: container })
    }
  }, [elements, setElements, container, id])
  
  return (
    <TextWidth>
      <>
        <Container ref={setContainer}>
          <HorizontalLine />
          {!hideNumbers && <Number>{parseInt(id) + 1}</Number>}
          <Text>{text}</Text>
          {sub && <Sub>{sub}</Sub>}
        </Container>
      </>
    </TextWidth>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 1.85em;
  margin-bottom: 3rem;
  @media (max-width: 831px) {
    margin-bottom: 2rem;
  }
  margin-top: 3rem;
  text-align: center;
`
const HorizontalLine = styled.div`
  width: 60px;
  height: 2px;
  background-color: var(--gray-4);
  margin-bottom: 4rem;
`
const Number = styled.div`
  color: var(--num-color);
  position: relative;
  width: 4rem;
  height: 4rem;
  background-color: var(--num-background);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
  @media (max-width: 831px) {
    margin-bottom: 2rem;
  }
  font-size: 2.4rem;
  font-weight: 800;
  font-family: var(--font-sans-serif);
  line-height: 0;
`

const Text = styled.h2`
  font-family: var(--font-sole);
  font-weight: 600;
  font-size: 2.4rem;
  line-height: 2.7rem;
  max-width: 510px;
  margin: 0;
`

const Sub = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 0.65em;
  margin-top: 0.35em;
`
export default Title
